import { wrapMiddlewaresWithSentry } from '@sentry/tanstackstart-react';
if (typeof window === "undefined") {
  console.log(
    "Starting CNApex Club server...",
    import.meta.env.DEV ? "(development mode)" : "(production mode)",
  );
}

import { createStart } from "@tanstack/react-start";
import { sentryGlobalFunctionMiddleware } from "@sentry/tanstackstart-react";

import { sentryRequestMiddleware } from "./observability/sentry-request-middleware";

export const startInstance = createStart(() => {
  return {
    requestMiddleware: wrapMiddlewaresWithSentry({ sentryRequestMiddleware }),
    functionMiddleware: wrapMiddlewaresWithSentry({ sentryGlobalFunctionMiddleware }),
  };
});
